var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 13.3334V9.16671M10.0002 13.3334V6.66671M13.3335 13.3334V11.6667M15.0002 3.33337H5.00016C4.55814 3.33337 4.13421 3.50897 3.82165 3.82153C3.50909 4.13409 3.3335 4.55801 3.3335 5.00004V15C3.3335 15.4421 3.50909 15.866 3.82165 16.1786C4.13421 16.4911 4.55814 16.6667 5.00016 16.6667H15.0002C15.4422 16.6667 15.8661 16.4911 16.1787 16.1786C16.4912 15.866 16.6668 15.4421 16.6668 15V5.00004C16.6668 4.55801 16.4912 4.13409 16.1787 3.82153C15.8661 3.50897 15.4422 3.33337 15.0002 3.33337Z",
    stroke: "#A0A0A0",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.3f00e2729394a3cf6a2c3441273eb4c2.svg";
export { ForwardRef as ReactComponent };